import type { MetadadosAnotacaoInterna } from '@/services/anotacoes-internas/anotacoes-internas.service';
import { motivoLabel, toMinutes, type MotivoAusencia } from './rodizio-logic';

/** Quantos indisponíveis a frase nomeia antes de resumir em "e mais N". */
const MAX_INDISPONIVEIS_NA_FRASE = 5;

const minuscula = (s: string) => (s ? s[0].toLowerCase() + s.slice(1) : s);

/**
 * Frase da anotação `RODIZIO`. Espelha `montarRodizio` do whiz-server
 * (frase-evento-anotacao.util.ts): o servidor congela uma cópia em `conteudo`
 * para exportação, e duas redações divergentes seriam duas verdades.
 */
export function fraseRodizio(meta: NonNullable<MetadadosAnotacaoInterna> | Record<string, never>): string {
    const m = meta as NonNullable<MetadadosAnotacaoInterna>;
    const politica = m.tipoRodizio === 'RESPEITA_JORNADA_TRABALHO' ? 'Rodízio por horário' : 'Rodízio normal';
    const canal = m.nomeCanal ? ` do canal ${m.nomeCanal}` : '';
    const quem = m.nomeUsuarioSorteado;
    const semNinguem = 'nenhum atendente disponível, o atendimento ficou na fila do canal';

    if (!m.fallback) {
        return quem ? `${politica}${canal} atribuiu o atendimento a ${quem}` : `${politica}${canal}: ${semNinguem}`;
    }

    const lista = m.indisponiveis ?? [];
    const nomes = lista
        .slice(0, MAX_INDISPONIVEIS_NA_FRASE)
        .map(i => `${i.nome}: ${minuscula(motivoLabel(i.motivo as MotivoAusencia, toMinutes(i.ate)) ?? i.motivo)}`);
    if (lista.length > MAX_INDISPONIVEIS_NA_FRASE) nomes.push(`e mais ${lista.length - MAX_INDISPONIVEIS_NA_FRASE}`);
    const fora = nomes.length ? ` (${nomes.join('; ')})` : '';

    return quem
        ? `${politica}${canal}: ninguém em turno${fora}. Caiu no rodízio normal e atribuiu a ${quem}`
        : `${politica}${canal}: ninguém em turno${fora}. Caiu no rodízio normal: ${semNinguem}`;
}
